import { Monitor, Smartphone, Atom } from "lucide-react";

export default function Services() {
  const services = [
    {
      icon: Monitor,
      title: "Веб-разработка",
      description: "Создаём современные веб-приложения и сайты с акцентом на производительность и пользовательский опыт",
      features: ["SPA и PWA", "E-commerce платформы", "Корпоративные порталы"],
      gradient: "from-sprintwise-primary to-sprintwise-secondary"
    },
    {
      icon: Smartphone,
      title: "Мобильная разработка",
      description: "Разрабатываем кроссплатформенные и нативные мобильные приложения для iOS и Android",
      features: ["React Native / Flutter", "Angular / Ionic", "Нативная разработка", "UI/UX дизайн"],
      gradient: "from-sprintwise-secondary to-sprintwise-accent"
    },
    {
      icon: Atom,
      title: "Интеграции и API",
      description: "Создаём надёжные API и интегрируем внешние сервисы для расширения функционала продукта",
      features: ["REST API / GraphQL", "Микросервисы", "Внешние интеграции"],
      gradient: "bg-gradient-to-r from-blue-500 to-purple-600"
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-sprintwise-dark mb-6" data-testid="services-title">
            Наши <span className="gradient-text">услуги</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-testid="services-description">
            Полный цикл разработки цифровых продуктов от идеи до успешного запуска и масштабирования
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="neon-border rounded-2xl p-8 hover:shadow-xl transition-all duration-300 group" data-testid={`service-card-${index}`}>
              <div className={`w-16 h-16 bg-gradient-to-r ${service.gradient} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <service.icon className="text-white text-2xl" />
              </div>
              <h3 className="text-2xl font-semibold text-sprintwise-dark mb-4" data-testid={`service-title-${index}`}>
                {service.title}
              </h3>
              <p className="text-gray-600 mb-6" data-testid={`service-description-${index}`}>
                {service.description}
              </p>
              <ul className="text-sm text-gray-500 space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center" data-testid={`service-feature-${index}-${featureIndex}`}>
                    <svg className="w-4 h-4 text-green-500 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
